{
  "accountTitle": "اکاؤنٹ ٹائٹل",
  "accountWalletName": "اکاؤنٹ / والٹ کا نام",
  "approvedBalance": "منظور شدہ بیلنس",
  "approvedRewards": "منظور شدہ انعامات",
  "availableBalance": "دستیاب بیلنس",
  "balance": "بیلنس",
  "bank": "بینک",
  "bnbWallet": "BNB والٹ",
  "buyBnbUsdt": "BNB / USDT خریدیں",
  "buyBnbUsdtText": "اپنے والیٹ کو فنڈ کرنے کے لیے براہ راست BNB یا USDT خریدیں۔",
  "buyCryptoSubtitle": "محفوظ طریقے سے کرپٹو خریدیں اور اپنا EXALT والیٹ فنڈ کریں۔",
  "buyExaltCoin": "EXALT کوائن خریدیں",
  "buyExaltOnPancake": "PancakeSwap پر EXALT خریدیں",
  "connectedWallet": "کنیکٹڈ والٹ",
  "copied": "کاپی ہو گیا",
  "copyAddress": "ایڈریس کاپی کریں",
  "copyContract": "کنٹریکٹ کاپی کریں",
  "copyExaltContract": "EXALT کنٹریکٹ ایڈریس کاپی کریں",
  "copyFailed": "کاپی ناکام ہوئی",
  "copyIban": "IBAN کاپی کریں",
  "copyNumber": "نمبر کاپی کریں",
  "deposit": "ڈپازٹ",
  "depositAddress": "ڈپازٹ ایڈریس",
  "depositFailed": "ڈپازٹ ناکام ہو گیا",
  "depositRequest": "ڈپازٹ ریکویسٹ",
  "depositRequiredFields": "نام، اکاؤنٹ/والٹ اور رقم ضروری ہے",
  "depositSubmittedSuccessfully": "ڈپازٹ ریکویسٹ کامیابی سے جمع ہو گئی",
  "estimatedExchangeWalletValue": "تخمینی ایکسچینج والٹ ویلیو",
  "exaltContractCopied": "EXALT کنٹریکٹ ایڈریس کاپی ہو گیا۔",
  "exaltWallet": "EXALT والٹ",
  "fakeSupportReminder": "جعلی سپورٹ ایجنٹس سے ہوشیار رہیں۔ Exalt Exchange کا عملہ کبھی بھی آپ کا پاس ورڈ یا پرائیویٹ کیز نہیں مانگے گا۔",
  "loadingWallet": "والیٹ لوڈ ہو رہا ہے...",
  "lockedBalance": "مقفل بیلنس",
  "pendingRewards": "زیر التواء انعامات",
  "readyTradingWithdrawal": "ٹریڈنگ یا ودڈرال کے لیے تیار",
  "refreshBalance": "بیلنس ریفریش کریں",
  "securityAdminApproval": "والٹ کریڈٹ سے پہلے ایڈمن منظوری ضروری ہے",
  "securityBackendApproval": "تمام ڈپازٹ اور ودڈرال ریکارڈ بیک اینڈ منظوری سے محفوظ ہیں",
  "securityLicensedGateways": "بینک/کارڈ ادائیگیاں صرف لائسنس یافتہ گیٹ ویز سے منسلک ہیں",
  "securityNoAutoRelease": "تصدیق کے بغیر خودکار ٹوکن ریلیز نہیں ہوگی",
  "securityReminder": "سیکیورٹی یاد دہانی",
  "securitySystem": "سیکیورٹی سسٹم",
  "securityWalletVerification": "صارف کے والٹ ایڈریس کی تصدیق ضروری ہے",
  "sellSwapBack": "فروخت کریں / واپس تبدیل کریں",
  "sellSwapBackText": "اپنے EXALT کو کسی بھی وقت BNB یا USDT میں واپس تبدیل کریں۔",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "step1": "مرحلہ 1",
  "step2": "مرحلہ 2",
  "step3": "مرحلہ 3",
  "submitDeposit": "ڈپازٹ جمع کریں",
  "submitWithdrawal": "ودڈرال جمع کریں",
  "swapToExaltText": "اپنے BNB یا USDT کو EXALT میں تبدیل کریں۔",
  "totalAssets": "کل اثاثے",
  "totalPortfolioValue": "کل پورٹ فولیو ویلیو",
  "transactionHashReference": "ٹرانزیکشن ہیش / ریفرنس آئی ڈی",
  "transfer": "منتقلی",
  "usdtWallet": "USDT والٹ",
  "useBscReminder": "ہمیشہ BNB سمارٹ چین (BEP-20) نیٹ ورک استعمال کریں۔",
  "verifyContractReminder": "ٹریڈنگ سے پہلے ہمیشہ سرکاری کنٹریکٹ ایڈریس کی تصدیق کریں۔",
  "waitingAdminApproval": "ایڈمن منظوری کا انتظار",
  "wallet": "والیٹ",
  "walletAddress": "والٹ ایڈریس",
  "walletBankIbanPlaceholder": "والٹ ایڈریس / جاز کیش / ایزی پیسہ / بینک اکاؤنٹ / IBAN",
  "walletNotConnected": "والٹ کنیکٹ نہیں ہے",
  "walletStatus": "والٹ اسٹیٹس",
  "walletsSubtitle": "اپنے کرپٹو والٹ، ڈپازٹ، ودڈرال اور ادائیگی کی درخواستوں کا انتظام کریں۔",
  "walletsTitle": "والیٹس",
  "withdraw": "نکالیں",
  "withdrawRequiredFields": "رقم، اکاؤنٹ کا نام اور والٹ/اکاؤنٹ نمبر ضروری ہے",
  "withdrawalFailed": "ودڈرال ناکام ہو گیا",
  "withdrawalRequest": "ودڈرال ریکویسٹ",
  "withdrawalSubmittedSuccessfully": "ودڈرال ریکویسٹ کامیابی سے جمع ہو گئی",
  "yourName": "آپ کا نام"
}